export const getChartLabel = (filters = {}, selectedState = []) => {
  const { StartYear, EndYear, StartMonth, EndMonth } = filters;

  const isAllStatesSelected =
    selectedState.length === 0 ||
    selectedState.some(
      (state) => state.value === "" || state.value === "ALL"
    );

  const stateLabel = isAllStatesSelected
    ? ""
    : selectedState.map((state) => state.label).join(", ");

  let dateLabel = "";

  // StartYear & EndYear available
  if (StartYear && EndYear) {
    // Same year
    if (StartYear === EndYear) {
      if (StartMonth && EndMonth) {
        dateLabel =
          StartMonth === EndMonth
            ? `${StartMonth} ${StartYear}`
            : `${StartMonth} to ${EndMonth} ${StartYear}`;
      } else {
        dateLabel = `${StartYear}`;
      }
    }
    // Different years
    else {
      if (StartMonth && EndMonth) {
        dateLabel = `${StartMonth} ${StartYear} to ${EndMonth} ${EndYear}`;
      } else {
        dateLabel = `${StartYear} to ${EndYear}`;
      }
    }
  }

  if (isAllStatesSelected) {
    return dateLabel ? `- ${dateLabel}` : "";
  }

  return dateLabel
    ? `of ${stateLabel} - ${dateLabel}`
    : `of ${stateLabel}`;
};